import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CourseAssignment } from './@types';

export async function deleteCourseAssignment(
   course_assignmentid: number,
   common: CommonRequestOptions = {}
): Promise<CourseAssignment> {
   return makeRequest('delete', `course_assignments/${course_assignmentid}`, common);
}

type DeleteCourseAssignmentErrorCode =
   | 'course_assignments.cancel.insufficent_privileges'
   | 'course_assignments.cancel.course_not_found'
   | 'course_assignments.cancel.course_cancelled';

deleteCourseAssignment.errorMessages =
   createErrorMessageTypeGuard<DeleteCourseAssignmentErrorCode>();
